import { type FC } from "react";

export const IconMoment: FC<{ size: 16 | 20 | 24 | 32 | 48 | 64 }> = ({ size }) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 64 64"
			fill="currentColor"
			xmlns="http://www.w3.org/2000/svg"
			role="img"
			aria-hidden="true"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.2718 44.728C12.2426 37.6986 12.2427 26.3018 19.2721 19.2725C26.3015 12.243 39.0711 10.7872 48.9706 15.0298L44.7264 19.274C51.7555 26.3035 51.7554 37.7002 44.7261 44.7296C37.6967 51.759 24.9289 53.2131 15.0294 48.9705L19.2718 44.728ZM39.0708 24.929C35.1655 21.0241 28.8341 21.0242 24.9289 24.9293C21.0237 28.8346 21.0237 35.1662 24.9289 39.0715L24.9274 39.073C28.8327 42.978 35.1641 42.9779 39.0692 39.0727C42.9745 35.1675 42.9745 28.8358 39.0692 24.9306L39.0708 24.929Z"
			/>
		</svg>
	);
};
